import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_pusher_state.js";
//#region src/kiosk_pusher_state_helper.ts
var kiosk_pusher_state_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(pusherState) {
	switch (pusherState) {
		case 0: return "disconnected";
		case 1: return "connecting";
		case 2: return "connected";
		case 3: return "subscribed";
	}
}
//#endregion
export { kiosk_pusher_state_helper_exports, name };

//# sourceMappingURL=kiosk_pusher_state_helper.js.map